module.exports = __webpack_public_path__ + "files/c1986fe1609f19787c6caa71c1687004.png";